<template>
  <div class="gameDetails" v-if="content.length != 0" id="gameDetails">
    <!-- 导航栏 -->
    <van-nav-bar :border="false" :fixed="true" z-index="10">
      <van-icon
        name="arrow-left"
        slot="left"
        size=".7rem"
        color="#FF9D11"
        @click="onBack"
      />
    </van-nav-bar>
    <!-- 背景 -->
    <div class="detail-bg">
      <img :src="gameDetail.bg_url" alt />
    </div>
    <section class="detail-wrapper" ref="hehe">
      <!-- 内容 -->
      <div class="detail-cont" ref="detailCont">
        <!-- 游戏 -->
        <div class="detail-game">
          <div class="dis-game">
            <div class="i-game">
              <img :src="gameDetail.icon_url" alt="今日主推" />
            </div>
            <div class="game-des">
              <div class="game-name-size">
                <span>{{ gameDetail.game_name }}</span>
                <span v-if="false">547.25M</span>
              </div>
              <div class="game-title">
                <span>{{ gameDetail.short_info }}</span>
              </div>
              <div class="dis-type-rate">
                <!-- 类型 -->
                <p>
                  <span
                    v-for="(item, index) in gameType(gameDetail.game_type_name)"
                    :key="index"
                    v-show="index == 0"
                    >{{ item }}</span
                  >
                  <span>|</span>
                  <span>{{ gameDetail.package_size }}</span>
                </p>
                <p>
                  <span>{{ gameDetail.star }}</span>
                  <van-rate
                    v-model="value"
                    allow-half
                    void-icon="star"
                    size="12px"
                    void-color="#fff"
                    :readonly="true"
                    color="#FE9D12"
                  />
                </p>
              </div>
            </div>
            <div class="game-down" v-if="false">
              <a v-if="true">下载</a>
              <a v-else>开玩</a>
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <van-tabs
          v-model="active"
          background="transparent"
          :border="false"
          title-inactive-color="#fff"
          title-active-color="#fff"
          line-width="10%"
          color="#fff"
          @click="click"
        >
          <van-tab title="详情" duration="5">
            <!-- 详情内容 -->
            <section ref="contW" class="cont-wrapper">
              <!-- 滚动宣传图 -->
              <div class="scroll-x">
                <div class="cont-img-box">
                  <div
                    class="imgs"
                    v-for="(item, index) in banners"
                    :key="index"
                    @click="showImagePreview(banners)"
                  >
                    <img :src="item.url" alt="宣传图" />
                  </div>
                </div>
              </div>
              <!-- 游戏介绍 -->
              <div class="cont-brief">
                <p class="brief-title">【游戏介绍】</p>
                <p class="brief-cont">{{ gameDetail.game_info }}</p>
              </div>
              <!-- 游戏特色 -->
              <div class="cont-ts">
                <p class="ts-title">【游戏特色】</p>
                <p class="ts-cont">{{ gameDetail.special_info }}</p>
              </div>
            </section>
          </van-tab>
          <van-tab title="攻略" duration="5">
            <!-- 攻略 -->
            <section ref="introduction" class="introduction">
              <div class="introduction-list">
                <router-link
                  v-for="(item, index) in gameStrategy"
                  :key="index"
                  tag="p"
                  :to="{
                    name: 'strategyDetail',
                    query: { id: item.strategy_id },
                  }"
                  >{{ item.title }}</router-link
                >
              </div>
              <!-- 更多 -->
              <router-link
                v-if="gameStrategy.length != 0 && gameStrategy.length > 5"
                tag="p"
                :to="{
                  name: 'strategyList',
                  query: { gameid: gameStrategy[0].gid },
                }"
                class="moreStrategy"
                >更多</router-link
              >
            </section>
          </van-tab>
          <van-tab title="礼包" duration="5">
            <!-- 礼包 -->
            <section ref="gift" class="gift">
              <div class="gift-lists">
                <div
                  class="gift-list"
                  v-for="(item, index) in gameGift"
                  :key="index"
                >
                  <router-link
                    tag="p"
                    :to="{ name: 'giftDetails', query: { id: item.gift_id } }"
                    >{{ item.title }}</router-link
                  >
                  <router-link
                    tag="p"
                    :to="{ name: 'giftDetails', query: { id: item.gift_id } }"
                    >{{ item.summary }}</router-link
                  >
                  <!-- <span class="get" @click="getCode(item.gift_id)">领取</span> -->
                  <span class="get" @click="getCode(item.gift_id)">领取</span>
                </div>
              </div>
              <van-pagination
                v-model="currentPage"
                :total-items="24"
                :items-per-page="5"
                v-if="false"
              />
            </section>
          </van-tab>
        </van-tabs>
      </div>
      <!-- downBtn -->
      <div
        class="downBtn"
        @click.stop="
          downGame(gameDetail.down_url, gameDetail.pid, gameDetail.gid)
        "
      >
        <span class="iocn">安装</span>
      </div>
    </section>
    <!-- Dialog 弹出框组件 -->
    <van-overlay :show="show" />
    <div class="dialog" v-show="show" title="领取成功" width="70%">
      <p class="g-title">领取成功</p>
      <p class="g-code">
        <span>礼包码</span>:
        <span class="code">{{ this.code }}</span>
      </p>
      <p class="confirm" @click="copyCode">
        <span>复制</span>
      </p>
    </div>
  </div>
</template>

<script>
import { contTools, lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
import { ImagePreview } from "vant"; // ImagePreview 是一个函数，调用函数后会直接在页面中展示图片预览界面
export default {
  name: "gameDetails",
  mixins: [contTools, lyTool],
  components: {},
  data() {
    return {
      imgList: require("@/assets/image/detail/xc.png"),
      tabList: ["详情", "攻略", "礼包"],
      content: [], // 详情内容集合
      detailContH: "",
      gameDetail: "",
      gameGift: "",
      gameStrategy: "",
      banners: "",
      scrollTop: 0, // 滚动距离
      active: 0,
      value: 0, // 评分
      changeIndex: 1, //
      currentPage: 1,
      strPage: 1, // 起始页
      totalPages: 12, // 总页数
      code: "88888",
      show: false,
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.initData();
    // this.$refs.detailCont.style.background = "skyblue";
    // this.$nextTick(() => {
    //   window.addEventListener("scroll", this.handleScroll, true);
    // });
  },
  methods: {
    // 初始化界面
    initData() {
      let data = comTools.assignObj(this.wapConfig(), {
        gid: this.urlObj.gameid,
        mobile: this.$cookies.get("mobile"),
      });
      data.sign = comTools.querySort(data);
      wapApiFun.gameDetail(data).then((res) => {
        if (res.code == 200) {
          this.content = res.data;
          this.gameDetail = this.content.game_detail;
          this.value = Number(this.gameDetail.star);
          this.banners = JSON.parse(this.gameDetail.banner_url);
          this.gameStrategy = this.content.game_strategy;
          this.gameGift = this.content.game_gift;
        }
        // console.log("游戏详情", res.data);
        console.log("游戏详情", this.content);
      });
    },
    // 图片放大预览
    showImagePreview(_images) {
      let images = [];
      for (const url in _images) {
        if (_images.hasOwnProperty(url)) {
          const element = _images[url];
          images.push(element.url);
        }
      }
      ImagePreview({
        images,
        startPosition: 0,
        closeOnPopstate: true,
        className: "w70",
        getContainer: function() {
          return document.querySelector("#gameDetails");
        },
      });

      // ImagePreview([
      //   "https://img.yzcdn.cn/vant/apple-1.jpg",
      //   "https://img.yzcdn.cn/vant/apple-2.jpg"
      // ]);
    },
    // 详情的中的攻略不为空
    isStrategy(item) {
      console.log("item", item);
    },
    // 攻略&&礼包tabs切换
    onChange(index) {
      this.changeIndex = index;
    },

    onBack() {
      this.$router.go(-1);
    },
    // 礼包详情
    getCode(id) {
      if (this.$cookies.get("userToken")) {
        let urlObj = comTools.getRequest();
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.$cookies.get("mobile"),
          user_token: this.$cookies.get("userToken"),
          gift_id: id,
        });
        data.sign = comTools.querySort(data);
        wapApiFun.giftGet(data).then((res) => {
          if (res.code == 200) {
            //  res.data.gift_code;
            this.code = res.data.gift_code;
            this.show = true;
          } else {
            this.$toast(res.msg);
          }
        });
      } else {
        this.$router.push({
          name: "login",
          query: { warn: 1001 },
        });
      }
    },
    // 复制礼包码
    copyCode() {
      let that = this;
      if (!this.code) {
        this.$toast("暂无礼包");
        return false;
      }
      this.$copyText(this.code).then(
        function(e) {
          that.$toast("复制成功");
          that.show = false;
        },
        function(e) {
          that.$toast("该浏览器不支持自动复制");
          that.show = false;
        }
      );
    },
    // 上一页
    onPreviousPage() {
      if (this.strPage !== 1) {
        this.strPage--;
      } else {
        this.$toast("人家是第一页了");
      }
    },
    // 下一页
    onNextPage() {
      console.log("下一页");
      if (this.strPage >= this.totalPages) {
        this.$toast("人家是最后一页了");
      } else {
        this.strPage++;
      }
    },
    // 吸顶事件
    handleScroll() {
      // console.log(this.$refs.detailCont.style);
      // this.scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      // console.log(this.scrollTop);
      // let _opacity = this.scrollTop / 250;
      // if (_opacity < 0.1) return 0.1;
      // if (!_opacity < 0.1)
      //   return (this.$refs.detailCont.style.background = `rgba(222,125,44,${_opacity})`);
    },
    // 点击标签时触发
    click(name, title) {
      // this.scrollTop = 0;
      // this.$refs.detailCont.style.background = `rgba(222,125,44,.1)`;
      // if (name == 1) {
      //   console.log(this.$refs.introduction.offsetHeight);
      // } else if (name == 2) {
      //   console.log(this.$refs.gift);
      // }
    },
    //
    // rendered(name, title) {
    //   if (name == 0) {
    //     console.log(this.$refs.contW.offsetHeight);
    //   } else if (name == 1) {
    //     this.$refs.introduction.style.paddingBottom = this.scrollTop + "px";
    //     // height+this.scrollTop
    //   } else {
    //     console.log(this.$refs.gift.offsetHeight);
    //   }
    // }
  },
  // beforeDestroy() {
  //   console.log("销毁");
  //   window.removeEventListener("scroll", this.handleScroll);
  // }
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/com.less";
.gameDetails {
  width: 100%;
  // overflow: hidden;
  // position: relative;
  // 导航栏
  .van-nav-bar {
    background: transparent;
  }

  // 底部背景
  .detail-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    img {
      .img();
    }
  }
  // 详情内容
  .detail-wrapper {
    width: 100%;
    position: relative;
    // 内容
    .detail-cont {
      clear: both;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      padding-bottom: 1rem;
      margin-top: 10rem;
      background: rgba(0, 0, 0, 0.5);
      // border-top: 10rem solid #fff;
      z-index: 9;
      // 游戏
      .dis-game {
        width: 100%;
        padding-top: 0.5rem;
        margin-bottom: 0.5rem;
        display: flex;
        .i-game {
          width: 2.5rem;
          margin: 0 0.4rem;
          img {
            .img();
          }
        }
        .game-des {
          width: 40%;
          flex-direction: column;
          display: flex;
          margin-right: 1rem;
          .game-name-size {
            span {
              &:nth-of-type(1) {
                font-size: 0.5rem;
                padding-right: 0.3rem;
                color: #fff;
              }
              &:nth-of-type(2) {
                .font-color();
                font-size: 0.35rem;
              }
            }
          }
          .game-type {
            color: #999;
            span {
              padding-right: 0.2rem;
              font-size: 0.4rem;
            }
          }
          .game-title {
            color: #fff;
            font-size: 0.3rem;
            margin-bottom: 0.1rem;
          }
          .dis-type-rate {
            margin-top: 0.1rem;
            p {
              &:nth-of-type(1) {
                color: #fff;
                font-size: 0.3rem;
                span {
                  &:nth-of-type(2) {
                    padding: 0 2px;
                    font-size: 0.3rem;
                  }
                }
              }
              &:nth-of-type(2) {
                color: #fe9d12;
                span {
                  padding-right: 0.2rem;
                }
              }
            }
          }
        }
        .game-down {
          .theme-bg-color();
          border-radius: 0.2rem;
          padding: 0.1rem 0.4rem;
          a {
            color: #fff;
          }
        }
      }
      // 内容
      .cont-wrapper {
        width: 100%;
        // .hideScrollBar();
        .scroll-x {
          position: relative;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          .cont-img-box {
            overflow-x: scroll;
            overflow-y: hidden;
            // background-color: #fff;
            .imgs {
              padding: 0.5rem 0;
              width: 5rem;
              margin-left: 0.2rem;
              display: inline-block;
              &:last-child {
                margin-right: 0.4rem;
              }
              img {
                .img();
              }
              // float: left;
            }
          }
        }
        .cont-brief,
        .cont-ts {
          color: #fff;
          font-size: 0.4rem;
          .brief-title,
          .ts-title {
            padding-left: 0.2rem;
          }
          .brief-cont,
          .ts-cont {
            padding: 0 0.4rem;
            text-indent: 1rem;
          }
        }
        .cont-ts {
          margin-top: 0.5rem;
          margin-bottom: 2rem;
        }
      }
      // 攻略
      .introduction {
        padding: 0 0.4rem;
        // padding-bottom: 1rem;
        .introduction-list {
          margin-bottom: 1rem;
          p {
            color: #fff;
            width: 98%;
            font-size: 0.4rem;
            padding: 0.3rem 0;
            .ellipsis();
            border-bottom: 0.01rem solid #fff;
            margin: 0 auto;
          }
        }
        .moreStrategy {
          color: #f00;
          text-align: center;
        }
      }
      // 礼包
      .gift {
        padding: 0 0.4rem;
        // padding-bottom: .5rem;
        .gift-lists {
          margin-bottom: 1rem;
          .gift-list {
            position: relative;
            color: #fff;
            width: 98%;
            font-size: 0.4rem;
            padding: 0.3rem 0;

            border-bottom: 0.01rem solid #fff;
            margin: 0 auto;
            p {
              &:nth-of-type(2) {
                width: 75%;
                .ellipsis();
              }
            }
            .get {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translate(0, -50%);
              padding: 0.1rem 0.3rem;
              border-radius: 0.2rem;
              .theme-bg-color();
            }
          }
        }
      }
    }
  }

  // banner 区域
  .banner {
    width: 100%;
    // margin-top: 46px;
    img {
      width: 100%;
    }
  }
  // 游戏
  .game-box {
    .gCont1 {
      display: flex;
      display: -webkit-flex;
      padding: 5%;
      .g-img {
        width: 2.4rem /* 180/75 */;
        margin-right: 0.2rem /* 15/75 */;
        img {
          width: 100%;
        }
      }
      .g-wrap-des {
        .g-name-type-size {
          .g-name {
            font-size: 0.6rem;
            padding: 0 0.2rem /* 15/75 */;
          }
          .g-type,
          .g-size {
            color: #999;
            font-size: 0.4rem /* 30/75 */;
          }
        }
        .g-birf {
          padding-left: 0.2rem;
          color: #999;
          font-size: 0.4rem /* 30/75 */;
        }
        .g-down {
          padding-left: 0.2rem;
          padding-top: 0.133333rem /* 10/75 */;
          a {
            color: #fff;
            background-color: #ff9d11;
            margin-right: 0.2rem /* 15/75 */;
            padding: 0.133333rem /* 10/75 */ 0.266667rem /* 20/75 */;
            font-size: 0.4rem /* 30/75 */;
            border-radius: 20px;
          }
        }
      }
    }
    .gCont2 {
      padding: 0 5%;
      padding-bottom: 0.266667rem /* 20/75 */;
      border-bottom: 8px solid #f3f3f3;
      .g-wrap-des {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        .score,
        .type,
        .size {
          display: flex;
          display: -webkit-flex;
          flex-direction: column;
          justify-content: space-around;
          p {
            &:nth-of-type(1) {
              color: #00a0e9;
              font-size: 0.466667rem /* 35/75 */;
            }
            &:nth-of-type(2) {
              padding-top: 0.2rem /* 15/75 */;
              color: #ff9d11;
              font-size: 0.466667rem /* 35/75 */;
            }
          }
        }
        .score {
          span {
            font-size: 0.6rem /* 45/75 */;
            padding-right: 0.2rem /* 15/75 */;
          }
          p {
            &:nth-of-type(2) {
              display: flex;
              display: -webkit-flex;
              align-items: center;
            }
          }
        }
        .size,
        .type {
          p {
            text-align: center;
          }
        }
      }
    }
  }
  // 攻略&&礼包
  .strategy-gift {
    .tabs {
      width: 100%;
      border-bottom: 0.013333rem /* 1/75 */ solid #e0e0e0;
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      .strategy-tab,
      .gift-tab {
        color: #999;
        padding: 0.266667rem /* 20/75 */ 0;
      }
      .active {
        color: #ff9d11;
        border-bottom: 1px solid #00a0e9;
      }
    }
    .strategy-box,
    .gift-box {
      padding: 0 5%;
      .cont-list {
        padding: 0.266667rem /* 20/75 */ 0;
        font-size: 0.4rem /* 30/75 */;
        border-bottom: 0.013333rem /* 1/75 */ solid #e0e0e0;
      }
    }
    .strategy-box {
      border-bottom: 8px solid #f3f3f3;
      .pagination {
        width: 70%;
        margin: 0 auto;
        // border: 1px solid #000;
        padding: 0.4rem /* 30/75 */ 0;
        display: flex;
        display: -webkit-flex;
        justify-content: space-around;
        align-items: center;
        .previous-page,
        .next-page {
          color: #ff9d11;
          font-size: 0.466667rem /* 35/75 */;
        }
        .active {
          color: #646566;
        }
        .pageNum-box {
          width: 40%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          span {
            text-align: center;
            padding: 0.066667rem /* 5/75 */ 0;
            &:nth-of-type(1) {
              color: #ff9d11;
            }
            // &:nth-of-type(2) {
            //   // border-left: none;
            //   border-left: none;
            //   color: #646566;
            //   background-color: #f7f8fa;
            // }
          }
        }
      }
    }
  }
  // 游戏截图
  .game-screenshot {
    padding-left: 5%;
    padding-top: 3%;
    .title {
      p {
        &:nth-of-type(1) {
          span {
            font-size: 0.6rem;
            padding: 0 0.133333rem /* 10/75 */;
            border-bottom: 0.013333rem /* 1/75 */ solid #000;
          }
        }
        &:nth-of-type(2) {
          font-size: 0.333333rem /* 25/75 */;
        }
      }
    }
    .rank-game-list {
      width: 95%;
      margin-top: 3%;
      overflow-x: scroll;
      overflow-y: hidden;
      // border: 1px solid #000;
      position: relative;
      min-height: 10.5rem;
      &::-webkit-scrollbar {
        // width: 5px;
        // height: 1px;
        background-color: transparent;
      }
      .game-list {
        position: absolute;
        left: 0;
        top: 0;
        width: 28.066667rem /* 2105/75 */;
        // 重点，为了不会换行显示
        display: flex;
        align-items: flex-end;
        overflow-x: auto;
        overflow-y: hidden;
        .rank-game {
          flex-shrink: 0;
          margin-right: 0.266667rem /* 20/75 */;
          position: relative;
          width: 6rem /* 400/75 */;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  // 游戏介绍
  .game-introduce {
    padding-left: 5%;
    .introduce-title {
    }
    .introduce-cont {
    }
  }

  // 游戏下载
  .downBtn {
    width: 80%;
    padding: 0.3rem 0;
    color: #fff;
    .theme-bg-color();
    .borderRadius();
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 20px;
    z-index: 88;
    text-align: center;
    // margin-bottom: 0.5rem;
  }
  // 弹窗组件
  .dialog {
    .transform(fixed);
    width: 70%;
    background-color: #fff;
    z-index: 10;
    .borderRadius(0.3rem);
    .g-title {
      text-align: center;
      padding-top: 0.3rem;
    }
    .g-code {
      text-align: center;
      padding: 0.3rem;
      .code {
        word-wrap: break-word;
      }
    }
    .confirm {
      text-align: center;
      padding-bottom: 0.3rem;
      letter-spacing: 0.1rem;
      span {
        .theme-bg-color();
        .borderRadius(0.2rem);
        color: #fff;
        padding: 0.2rem 20%;
        display: inline-block;
      }
    }
  }

  // vant图片预览组件自定义class
  /deep/.w70 {
    // background-color: #fff;
    img {
      width: 70%;
      margin: 0 auto;
    }
  }
}
</style>
